import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

export const useGetLegalDocuments = () => {
  const fetchLegalDocuments = useQuery(
    ['fetchLegalDocuments'],
    async () => {
      const response = await axios.get(`${process.env.REACT_APP_PUBLIC_API_URL}/legal-requirements`)

      return response.data
    },
    {
      retry: false,
      refetchOnWindowFocus: false
    }
  )

  return { data: fetchLegalDocuments.data, query: fetchLegalDocuments }
}
